import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    color: ({value}: {value:  number}) => value >= 0 ? theme.color.greens[100] : theme.color.reds[100],
  },
}), { name: 'PercentChange', index: StylesIndexInjections.UI_MOLECULES });
